<app-base-modal modalName="kbc-ulster-modal"
  [inProcessModal]="inProcessModal"
  [hideClose]="false"
  [customCloseAction]="modalActions.customCloseAction">
  <ng-template>
    <div id="kbc-ulster-modal"
      class="kbc-ulster-modal">
      <label id="modal_heading"
        class="modal-heading">
        {{s.headingText}}
      </label>
      <div class="scrollable-modal-section">
        <div class="kbc-ulster-desc ">
          <div class="ulster-sub-heading">{{s.para1Text}}</div>
          <div class="ulster-transfer-info">{{s.para2Text}}</div>
          <div class="ulster-transfer-cancel">
            {{s.para3aText}}
            <a href="tel:{{s.phoneNumberHref}}">{{s.phoneNumber}}</a>{{s.para3bText}}
          </div>
        </div>
      </div>

      <button id="kbc_ulster_modal_submit_button"
        type="submit"
        [disabled]="waiting"
        (click)="onAction()"
        class="app-submit-btn">
        <span id="kbc_ulster_modal_submit_text">{{s.agreeText}}</span>
        @if (waiting) {
          <div id="kbc_ulster_modal_submit_loader"
          class="loader"></div>
        }
      </button>
    </div>
  </ng-template>
</app-base-modal>